/**
 * @generated SignedSource<<8feb5c88460eb461fb78d22c4d1c2025>>
 * @relayHash 77c3bd30a907c854f4e2de64785adae5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4d12514a5e1e979317b9fb29a085b8c56ac042b222ff78badf2baae5baaa637d

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LeaveGuildInput = {
  clientMutationId?: string | null | undefined;
  guildId: string;
};
export type GuildCardPendingWithdrawMutation$variables = {
  input: LeaveGuildInput;
};
export type GuildCardPendingWithdrawMutation$data = {
  readonly leaveGuild: {
    readonly guild: {
      readonly " $fragmentSpreads": FragmentRefs<"GuildCardNew_guild">;
    } | null | undefined;
  } | null | undefined;
};
export type GuildCardPendingWithdrawMutation = {
  response: GuildCardPendingWithdrawMutation$data;
  variables: GuildCardPendingWithdrawMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildCardPendingWithdrawMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeaveGuildPayload",
        "kind": "LinkedField",
        "name": "leaveGuild",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildCardNew_guild"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildCardPendingWithdrawMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LeaveGuildPayload",
        "kind": "LinkedField",
        "name": "leaveGuild",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slugId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blueskyIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildMembership",
                "kind": "LinkedField",
                "name": "myMembership",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "membershipLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          {
                            "kind": "Literal",
                            "name": "dpr",
                            "value": 3
                          },
                          {
                            "kind": "Literal",
                            "name": "fit",
                            "value": "cover"
                          },
                          {
                            "kind": "Literal",
                            "name": "h",
                            "value": 100
                          },
                          {
                            "kind": "Literal",
                            "name": "w",
                            "value": 100
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "transform"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "backgroundPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "fit": "cover",
                          "h": 200,
                          "w": 500
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":200,\"w\":500})"
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 3,
                      "h": 200,
                      "w": 500
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "defaultBackgroundUrl",
                "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":3,\"h\":200,\"w\":500})"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4d12514a5e1e979317b9fb29a085b8c56ac042b222ff78badf2baae5baaa637d",
    "metadata": {},
    "name": "GuildCardPendingWithdrawMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "069e94f365b378407cd604e2ca813aad";

export default node;
